import { useQuery, UseQueryOptions } from 'react-query'
import { QUERY_KEYS } from 'constants/common'
import ROUTES from 'constants/routes'
import { getEnv, IS_STATIC_AUTH_ENABLED } from 'utils/environment'
import { BASE_PATH, farosApi } from '../faros-utils/axios'

interface StaticLicenseResult {
  isValid: boolean
  exp?: number
  seats?: number
  tier?: string
  modules?: Array<string>
}

export const checkStaticLicense = () =>
  farosApi.get<unknown, StaticLicenseResult>(ROUTES.API.LICENSE.ROOT, {
    baseURL: BASE_PATH,
  })

export const useStaticLicense = (
  options?: UseQueryOptions<StaticLicenseResult, Error>
) =>
  useQuery({
    queryKey: [QUERY_KEYS.STATIC_LICENSE_RESULT],
    queryFn: (): StaticLicenseResult | Promise<StaticLicenseResult> => {
      // return isValid: true if it's not on prem or it's dev environment
      if (!IS_STATIC_AUTH_ENABLED || process.env.NODE_ENV !== 'production') {
        return { isValid: true }
      }
      if (!getEnv('NEXT_PUBLIC_FAROS_STATIC_LICENSE')) {
        throw new Error('Missing static license')
      }
      return checkStaticLicense()
    },
    ...options,
  })
